/** @format */

import { useState } from "react";
import { Button, Card, Col } from "react-bootstrap";
import CertificateCard from "./certificate-card";

const CertLicenses = () => {
  const [isOpen, setOpen] = useState(false);
  const handleToggleSection = () => {
    setOpen(!isOpen);
    console.log("isOpen", isOpen);
  };

  return (
    <Col lg="12">
      <Card>
        <div className="w-full text-end">
          <Button
            variant="success"
            type="button"
            className="btn btn-success mt-4 fw-semibold text-uppercase me-3"
            onClick={handleToggleSection}
          >
            <i className="ri-add-fill" style={{ fontSize: "16px" }}></i> Import
            from FirstCert
          </Button>
          <Button
            variant="success"
            type="button"
            className="btn btn-success mt-4 fw-semibold text-uppercase"
            onClick={handleToggleSection}
          >
            <i className="ri-add-fill" style={{ fontSize: "16px" }}></i> Add New
            Certs or Licenses
          </Button>
        </div>
        <CertificateCard />
      </Card>
    </Col>
  );
};

export default CertLicenses;
